/* bc2-cart.js — Add-to-cart for the Breads & Cakes landing page.
   Adds the product with AJAX and opens the theme's cart drawer (where order bumps live).
   Falls back to the cart page if the drawer isn't available. */
(function () {
  if (window.__bc2Cart) return;
  window.__bc2Cart = true;

  var SECTIONS = ['cart-drawer', 'cart-icon-bubble'];
  var st = document.createElement('style');
  st.textContent = ".bc2-s a.bc2-cta.is-loading,a.bc2-sticky-btn.is-loading{opacity:.7;pointer-events:none;cursor:progress}\n.bc2-s a.bc2-cta.is-loading::after,a.bc2-sticky-btn.is-loading::after{content:\"\";width:16px;height:16px;margin-left:10px;border:2.5px solid rgba(255,255,255,.45);border-top-color:#fff;border-radius:50%;animation:bc2spin .7s linear infinite;flex:0 0 auto}\n@keyframes bc2spin{to{transform:rotate(360deg)}}";
  document.head.appendChild(st);
  function root() { return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/'; }
  function drawer() { return document.querySelector('cart-drawer'); }
  function goCart() { window.location.href = root() + 'cart'; }

  function fetchSections() {
    return fetch(root() + '?sections=' + SECTIONS.join(','), { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); });
  }

  function render(state) {
    var d = drawer();
    if (!d) return goCart();
    try {
      if (typeof d.renderContents === 'function') { d.renderContents(state); return; }
    } catch (e) { console.warn('bc2: renderContents failed', e); }
    try {
      var html = state.sections && state.sections['cart-drawer'];
      if (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('cart-drawer');
        if (fresh) { d.innerHTML = fresh.innerHTML; d.classList.remove('is-empty'); }
      }
      if (typeof d.open === 'function') { d.open(); return; }
    } catch (e) { console.warn('bc2: drawer fallback failed', e); }
    goCart();
  }

  function announce(id, state) {
    try {
      if (typeof window.publish === 'function' && window.PUB_SUB_EVENTS && PUB_SUB_EVENTS.cartUpdate) {
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'bc2-landing', productVariantId: id, cartData: state });
      }
    } catch (e) {}
    document.dispatchEvent(new CustomEvent('cart:updated', { detail: state }));
    document.dispatchEvent(new CustomEvent('bc2:added', { detail: { variantId: id, cart: state } }));
  }

  function addToCart(id) {
    return fetch(root() + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var inCart = (cart.items || []).some(function (i) { return i.variant_id === id; });
        if (inCart) {
          // Digital product: don't add a second copy, just show the cart.
          return fetchSections().then(function (s) { return { id: id, sections: s }; });
        }
        return fetch(root() + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify({ items: [{ id: id, quantity: 1 }], sections: SECTIONS.join(','), sections_url: window.location.pathname })
        }).then(function (r) {
          if (!r.ok) throw new Error('add failed ' + r.status);
          return r.json();
        }).then(function (state) {
          state.id = state.id || id;
          var ready = state.sections && state.sections['cart-drawer'] ? Promise.resolve(state)
            : fetchSections().then(function (s) { state.sections = s; return state; });
          return ready.then(function (st) { announce(id, st); return st; });
        });
      });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-bc2-atc]');
    if (!btn) return;
    var id = parseInt(btn.getAttribute('data-bc2-atc'), 10);
    if (!id) return;
    e.preventDefault();
    if (btn.getAttribute('aria-busy') === 'true') return;
    btn.setAttribute('aria-busy', 'true');
    btn.classList.add('is-loading');
    addToCart(id)
      .then(render)
      .catch(function (err) { console.warn('bc2: add to cart failed, using fallback', err); window.location.href = btn.href; })
      .then(function () { btn.removeAttribute('aria-busy'); btn.classList.remove('is-loading'); });
  });
})();
